// extracted by mini-css-extract-plugin
module.exports = {"contributors":"Contributors_contributors__W8Tt4","contributors__title":"Contributors_contributors__title__53nAe","contributors__list":"Contributors_contributors__list__inCCn"};